import { DropdownItem } from '@shared/abstraction';
import { TransactionType } from '@shared/helpers/enums/transaction-type';

export const transactionTypeItems: DropdownItem[] = [
  {
    value: TransactionType.All,
    label: 'All',
  },
  {
    value: TransactionType.GeneralRates,
    label: 'General rates',
  },
  {
    value: TransactionType.SpecificAdvice,
    label: 'Specific advice',
  },
];
